import { render, staticRenderFns } from "./DepreciationRunShow.vue?vue&type=template&id=a35ca90a&scoped=true"
import script from "./DepreciationRunShow.vue?vue&type=script&lang=js"
export * from "./DepreciationRunShow.vue?vue&type=script&lang=js"
import style0 from "./DepreciationRunShow.vue?vue&type=style&index=0&id=a35ca90a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a35ca90a",
  null
  
)

export default component.exports